import { render, staticRenderFns } from "./CountdownFlip.vue?vue&type=template&id=0228850c&scoped=true"
import script from "./CountdownFlip.vue?vue&type=script&lang=js"
export * from "./CountdownFlip.vue?vue&type=script&lang=js"
import style0 from "./CountdownFlip.vue?vue&type=style&index=0&id=0228850c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0228850c",
  null
  
)

export default component.exports